<template>
  <div>
    <svg-icon :icon-class="icon" v-if="iconId===null"/>
    <icon :iconId="iconId" v-else/>
    <span slot='title' class="title" :title="title.length>8?title:''">{{title}}</span>
    <transition name="el-zoom-in-center">
      <el-button 
        v-if="type === 0&&(operationType&2)===2"
        v-interval-click="{func:handleCreate,time:1000}"
        @click.prevent.stop="()=>{}"
        class='previewButton'
        size='mini'
        type='primary'>
        {{name||$t('buttons.create')}}
      </el-button>
      <el-button 
        v-else-if="type === 2"
        v-interval-click="{func:handleStartWrokFlow,time:1000}"
        @click.prevent.stop="()=>{}"
        class='previewButton'
        size='mini'
        type='primary'>
        {{$t('buttons.start')}}
      </el-button>
    </transition>
  </div>
</template>

<script>
import icon from './icon.vue'
export default {
  components: {
    icon
  },
  name: 'MenuItem',
  // functional: true,
  props: {
    iconId: {
      type: Number,
      default: null
    },
    name: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    type: {
      type: Number,
      default: 1
    },
    workFlowInfo: {
      type: Array,
      default: undefined
    },
    operationType: {
      type: Number,
      default: 0
    }
  },
  methods: {
    handleStartWrokFlow() {
      this.$emit('handleStartWrokFlow')
    },
    handleCreate() {
      this.$emit('handleCreate')
    }
  }
  // render(h, context) {
  //   const { icon, title, operationType } = context.props
  //   const vnodes = []

  //   if (icon) {
  //     vnodes.push(<svg-icon icon-class={icon}/>)
  //   }

  //   if (title) {
  //     vnodes.push(<span slot='title'>{(title)}</span>)
  //   }

  //   if (operationType === 1) {
  //     vnodes.push(<el-button @click="preview" round class='previewButton' size='mini' type='primary' icon='el-icon-view'></el-button>)
  //   }
  //   return vnodes
  // }
}
</script>
<style lang="scss" scoped>
  span.title{
    display: inline-block;
    width: calc(100% - 26px);
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>


